import { createAction } from "redux-actions";

export const login = createAction("LOGIN");
export const logout = createAction("LOGOUT");
export const loginFail = createAction("LOGINFAIL");
export const SetLocale = createAction("SETLOCALE");

export const getConverters = createAction("GETCONVERTERS");
export const getConvertersDone = createAction("GETCONVERTERSDONE");
export const getConverterConfigDone = createAction("GETCONVERTERCONFIGDONE");
export const addConverter = createAction("ADDCONVERTER");
export const addNConverters = createAction("ADDNCONVERTERS");
export const addMdl_V7Converter = createAction("ADDMDL_V7NCONVERTERS¡");
export const copyConverter = createAction("COPYCONVERTER");
export const removeConverter = createAction("REMOVECONVERTER");
export const updateConverterType = createAction("UPDATECONVERTERTYPE");
export const updateConverterMultipleMdl = createAction("UPDATECONVERTERMULTIPLEMDL");
export const updateConverterId = createAction("UPDATECONVERTERID");
export const updateConverterOrder = createAction("UPDATECONVERTERORDER");
export const getConverterConfig = createAction("GETCONVERTERCONFIG");
export const removeConfigParam = createAction("REMOVECONFIGPARAM");
export const setConfigParam = createAction("SETCONFIGPARAM");
export const setConfigConverter = createAction("SETCONFIGCONVERTER");

export const addConversion = createAction("ADDCONVERSION");
export const processConversion = createAction("PROCESSCONVERSION");
export const preProcessConversion = createAction("PREPROCESSCONVERSION");
export const getConversionStatus = createAction("GETCONVERSIONSTATUS");
export const updateStoreConversionStatus = createAction("UPDATESTORECONVERSIONSTATUS");
export const updateStoreConversionStatusDescription = createAction("UPDATESTORECONVERSIONSTATUSDESCRIPTION");
export const removeAllConversion = createAction("REMOVEALLCONVERSION");
export const getMDLData = createAction("GETMDLDATA");
export const getMDLDataDone = createAction("GETMDLDATADONE");
export const downLoadMDL = createAction("DOWLOADNMDL");
export const showMDLInPatternAssistant = createAction("SHOWMDLINPATTERNASSISTANT");
export const setEnableDownload = createAction("ENABLEDOWNLOADMDL");
export const setEnableCRUD = createAction("ENABLECRUD");

export const setDraggedConverter = createAction("DRAGGEDCONVERTER");
export const getListMultiZip = createAction("GETLISTMULTIZIP");
export const updateConversionStatus = createAction("UPDATECONVERSIONSTATUS");

export const startAskingConversionStatus = createAction("STARTASKINGCONVERSIONSTATUS");
export const stopAskingConversionStatus = createAction("STOPASKINGCONVERSIONSTATUS");
export const setTimer = createAction("SETTIMER");

export const setAuthNoAccess = createAction("AUTHNOACCESS");
export const setAuthRequiredPermissions = createAction("AUTHREQUIREDPERMISSIONS");
export const setAuthCurrentPermissions = createAction("AUTHCURRENTPERMISSIONS");
export const setOnlyOneFileAtTime = createAction("ONLYONEFILEATTIME");
export const setCreatedDefaultConverters = createAction("CREATEDDEFAULTCONVERTERS");

export const cancelPatternConverter = createAction("CANCELPATTERNCONVERTER");
export const donePatternConverter = createAction("DONEPATTERNCONVERTER");

export const setConvertersManagerOpen = createAction("SETCONVERTERSMANAGEROPEN");
export const setConverterConfigOpen = createAction("SETCONVERTERCONFIGOPEN");
export const setConverterOnEdition = createAction("SETCONVERTERONEDITION");
